import React from 'react';
import CinemaSVG from 'components/CinemaSVG/CinemaSVG';
import PropTypes from 'prop-types';


const MobileCinemaFilter = ({ onClick, selectedCinema, cinemas, brandClass }) => {
  const actualCinema = cinemas !== null ? cinemas.find(cinema => cinema.id === selectedCinema) : null;
  const cinemaReplacer = (name) => {
    let result = name;
    if (name.includes('artmozi')) {
      result = name.replace('artmozi', '');
    } else if (name.includes('Távmozi')) {
      result = name;
    } else if (name.includes('mozi')) {
      result = name.replace('mozi', '');
    } else if (name.includes('Mozi')) {
      result = name.replace('Mozi', '');
    }
    return result;
  };
  return (
    <React.Fragment>
      {
        cinemas !== null ? (
          <div className={`react-mozi-brand ${brandClass} react-cinema-filter-mobile-container`}>
            <div className={`react-mozi-brand ${brandClass} react-filter-mobile-title`}>Válassz mozit!</div>
            <div className={`react-mozi-brand ${brandClass} react-active react-filter-mobile-box cinema`} tabIndex={0} role="button" onClick={onClick}>
              <CinemaSVG cinema={actualCinema.logo} />
              <div className="react-cinema-filter-mobil-box-title">
                {cinemaReplacer(actualCinema.name)}
              </div>
            </div>
          </div>
        ) : null
      }
    </React.Fragment>
  );
};

MobileCinemaFilter.propTypes = {
  brandClass: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedCinema: PropTypes.number.isRequired,
  cinemas: PropTypes.arrayOf(PropTypes.shape({})),
};

MobileCinemaFilter.defaultProps = {
  cinemas: null,
};

export default MobileCinemaFilter;
